import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  header: {
    minHeight: '60px',
    height: '60px',
    background: theme.evPalette.salt[100],
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
    padding: 0,
    alignItems: 'center',
    position: 'sticky',
    top: '0',
    zIndex: '200',
    '@media (min-width: 1024px)': {
      position: 'relative',
      padding: '0px 0px 0px 24px',
      minHeight: '73px',
      height: '73px',
      '& >*': { height: '73px' },
    },
    '@media print': { display: 'none' },
  },
  dasboardHeaderLink: {
    display: 'flex',
    alignItems: 'center',
    height: 'fit-content',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '25px',
    letterSpacing: '0em',
  },
  backIcon: {
    display: 'block',
    marginTop: '12px',
    marginRight: '13px',
    transform: 'rotateZ(90deg)',
  },
  headerLinksContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    rowGap: '16px',
    alignItems: 'unset',
    '@media (min-width: 1024px)': {
      flexDirection: 'row',
      width: 'auto',
      maxWidth: '100%',
      justifyContent: 'flex-end',
      padding: 0,
      height: '100%',
    },
  },
  headerLinksListItem: {
    padding: 0,
    '&>*': { height: '100%' },
    '@media (min-width: 1024px)': {
      width: 'fit-content',
    },
  },
  logo: {
    width: '160px',
    height: 'auto',
    '@media (min-width:640px) and (max-width:1024px)': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  logoBtn: {
    borderRadius: 0,
    '&:hover': {
      borderRadius: 0,
    },
  },
  languageSelectorContainer: {
    width: '100%',
    display: 'flex',
    padding: '29px 7px',
    alignItems: 'center',
    '@media (min-width: 1024px)': {
      justifyContent: 'space-around',
      borderLeft: `1px solid ${theme.evPalette.charcoal[400]}`,
      width: '130px',
    },
  },
  language: {
    color: theme.evPalette.ocean[600],
    flex: '1 1 auto',
    marginLeft: '10px',
    '@media (min-width: 1024px)': {
      color: theme.evPalette.charcoal[700],
    },
  },
  languageDropdownIcon: {
    color: theme.evPalette.ocean[600],
    '@media (min-width: 1024px)': {
      color: theme.evPalette.charcoal[700],
    },
  },
  menuLink: {
    padding: '13px 10px',
    gap: '10px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    color: theme.evPalette.ocean[600],
    fontSize: theme.typography.pxToRem(16),
    textDecoration: 'none',
    fontWeight: 400,
    '& >a': {
      width: '100%',
      color: theme.evPalette.ocean[600],
      fontSize: theme.typography.pxToRem(16),
      textDecoration: 'none',
    },
    '@media (min-width: 1024px)': {
      width: 'unset',
      padding: '14px 16px',
      fontStyle: 'normal',
      fontSize: '14px',
      lineHeight: '20px',
      textAlign: 'center',
      fontWeight: 600,
      color: theme.evPalette.charcoal[700],
      '&:hover': {
        backgroundColor: theme.evPalette.charcoal[200],
      },
    },
    '& .supportIcon': {
      color: theme.evPalette.ocean[600],
    },
  },
  orderBtn: {
    width: '100%',
    textTransform: 'none',
    textDecoration: 'none',
    alignSelf: 'center',
    border: `1px solid ${theme.evPalette.ocean[600]}`,
    justifyContent: 'flex-start',
    color: `${theme.evPalette.ocean[600]} !important`,
    padding: '10px 16px',
    borderRadius: '4px',
    '@media (min-width: 1024px)': {
      width: 'unset',
      height: 'fit-content',
      margin: '13px 10px',
    },
  },
  selectedMenuLink: {
    backgroundColor: theme.evPalette.ocean[600],
    borderRadius: theme.typography.pxToRem(4),
    color: theme.evPalette.salt[100],
    '& >a': {
      color: theme.evPalette.salt[100],
    },
    '& .supportIcon': {
      color: theme.evPalette.salt[100],
    },
  },
  selectedPCMenuLink: {
    borderBottom: `2px solid ${theme.evPalette.ocean[500]}`,
  },
  orderButton: {
    textDecoration: 'none',
  },
  toggleMenuBtn: {
    padding: 0,
    width: '60px',
    minWidth: '60px',
    height: '100%',
    alignItems: 'center',
    borderRight: `1px solid ${theme.evPalette.charcoal[500]}`,
    marginRight: 17,
    borderRadius: '0px',
  },
  drawer: {
    marginTop: '60px',
    width: '300px',
  },
  paper: {
    position: 'static',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '20px 10px 30px 10px',
    background: theme.evPalette.salt[100],
    gap: '20px',
    '&.unauthorised': {
      justifyContent: 'space-between',
    },
  },
  avatarContainer: {
    width: '100%',
    padding: '8px 0px',
    '&>.myev-MuiButton-label': {
      justifyContent: 'space-between',
    },
    '@media (min-width: 1024px)': {
      width: 'auto',
    },
  },
  signOut: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 10px',
    cursor: 'pointer',
    backgroundColor: theme.evPalette.salt[100],
    border: 'none',
    gap: '10px',
    '&:hover': {
      backgroundColor: theme.evPalette.charcoal[100],
    },
  },
  signOutText: {
    marginLeft: '10px',
  },
  legacyRedirectionLinkContainer: {
    display: 'flex',
    minWidth: 'fit-content',
    alignItems: 'center',
    padding: '13px 10px',
  },
  legacyRedirectionLink: {
    fontSize: '16px',
  },
}));
